import React from 'react';
import styles from '@/styles/components/navigation/DropMenu.module.css';

interface DropMenuProps {
  username: string;
  email: string;
  walletBalance?: string;
  trialBalance?: number;
  onProfile?: () => void;
  onWallet?: () => void;
  onHistory?: () => void;
  onLogout?: () => void;
}

const DropMenu: React.FC<DropMenuProps> = ({
  username,
  email,
  walletBalance = '0.00 USD',
  trialBalance,
  onProfile,
  onWallet,
  onHistory,
  onLogout,
}) => {
  // Track hovered/active for visual feedback
  const [hovered, setHovered] = React.useState<string | null>(null);

  return (
    <div className={styles.dropMenu} style={{ minWidth: 320 }}>
      <div className={styles.listItems}>
        {/* User info */}
        <div className={styles.list}>
          <div className={styles.avatar}>
            <div className={styles.at}>
              {username.slice(0, 2).toUpperCase()}
            </div>
          </div>
          <div className={styles.textGroup}>
            <div className={styles.text}>{username}</div>
            <div className={styles.text1}>{email}</div>
          </div>
        </div>
        {/* Profile */}
        <div
          className={styles.list1}
          onClick={onProfile}
          style={{
            cursor: 'pointer',
            background:
              hovered === 'profile'
                ? 'var(--surface-surface_2, #F4F4F6)'
                : undefined,
          }}
          onMouseEnter={() => setHovered('profile')}
          onMouseLeave={() => setHovered(null)}
        >
          <img
            className={styles.leftIcon}
            alt=""
            src="/icons/profile_dropdown/user.svg"
          />
          <div className={styles.textGroup1}>
            <div className={styles.text}>Profile</div>
          </div>
        </div>
        {/* Wallet */}
        <div
          className={styles.list2}
          onClick={onWallet}
          style={{
            cursor: 'pointer',
            background:
              hovered === 'wallet'
                ? 'var(--surface-surface_2, #F4F4F6)'
                : undefined,
          }}
          onMouseEnter={() => setHovered('wallet')}
          onMouseLeave={() => setHovered(null)}
        >
          <img
            className={styles.leftIcon}
            alt=""
            src="/icons/profile_dropdown/wallet.svg"
          />
          <div className={styles.textGroup1}>
            <div className={styles.text}>Wallet</div>
          </div>
          <div className={styles.tags1}>
            <div className={styles.testWrap}>
              <div className={styles.text2}>{walletBalance}</div>
            </div>
            {trialBalance && trialBalance > 0 && (
              <div className={styles.trialTag}>
                {Math.round(trialBalance)} trial
              </div>
            )}
          </div>
        </div>
        {/* History */}
        <div
          className={styles.list3}
          onClick={onHistory}
          style={{
            cursor: 'pointer',
            background:
              hovered === 'history'
                ? 'var(--surface-surface_2, #F4F4F6)'
                : undefined,
          }}
          onMouseEnter={() => setHovered('history')}
          onMouseLeave={() => setHovered(null)}
        >
          <img className={styles.leftIcon} alt="" src="/icons/profile_dropdown/history.svg" />
          <div className={styles.textGroup1}>
            <div className={styles.text}>History</div>
          </div>
        </div>
        <div className={styles.separator}></div>
        {/* Log Out */}
        <div
          className={styles.list4}
          onClick={onLogout}
          style={{
            cursor: 'pointer',
            background:
              hovered === 'logout'
                ? 'var(--surface-surface_2, #F4F4F6)'
                : undefined,
          }}
          onMouseEnter={() => setHovered('logout')}
          onMouseLeave={() => setHovered(null)}
        >
          <img
            className={styles.leftIcon1}
            alt=""
            src="/icons/profile_dropdown/log_out.svg"
          />
          <div className={styles.textGroup1}>
            <div className={styles.text}>Log Out</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropMenu;
